import { css } from '@emotion/core';

import { alignItemsEnd, flexStart, spaceGapCompact } from '@/styles';

export const orgActionBarStyles = [
  flexStart,
  spaceGapCompact,
  alignItemsEnd,
  css`
    max-width: 600px;
    & > div {
      &:first-of-type {
        flex-grow: 1;
      }
    }
  `,
];
